





















































































































































































import { Component, Vue } from 'vue-property-decorator';
import nationSelect from '@/components/common/nationSelect.vue';
import deptSelect from '@/components/common/deptSelect.vue';
import birthDate from '@/components/common/birthdate.vue';
import confirmFeedback from '@/components/common/confirmFeedback.vue';
import axios from 'axios';
import UserModule from '@/store/modules/user';
import { Notify, Dialog, Toast } from 'vant';
import * as api from '@/api';
import { datetime } from '@/utils/filter';
import SessionModule from '@/store/modules/session';
import manageRank from '@/components/common/manageRank.vue';
import unManageRank from '@/components/common/unManageRank.vue';
import { StudentInfoDto } from '@/.generated/models';

@Component({
  components: { nationSelect, deptSelect, confirmFeedback, birthDate, manageRank, unManageRank },
})
export default class extends Vue {
  feedbackShow: boolean = false;
  feedbackType: string = '';
  successStatu: boolean = false;
  errorMsg: string = '';
  loading: boolean = false;
  finished: boolean = false;
  previewImg: any = '';
  showNationPicker: boolean = false;
  showDeptPicker: boolean = false;
  showDatePicker: boolean = false;
  stuImgs: any = [];
  ajaxUrl: any = apiAxios.getUri;

  postRankValue: string = '';
  unManageRankValue: string = '';
  showUnManageRankPicker: boolean = false; // 非管理职级组件显隐
  showManageRankPicker: boolean = false;
  showCitySelectorPicker: boolean = false;

  pcList: string[] = [
    '南宁市',
    '柳州市',
    '桂林市',
    '梧州市',
    '北海市',
    '防城港市',
    '钦州市',
    '贵港市',
    '玉林市',
    '百色市',
    '贺州市',
    '河池市',
    '来宾市',
    '崇左市',
  ];

  formDeptName: string = '';

  form: Partial<StudentInfoDto> = {
    id: UserModule.userId,
    deptId: '',
    // deptName: '',
    imageName: '',
    name: '',
    sex: '',
    nation: '',
    workUnit: '',
    job: '',
    birthday: '',
    postRank: null,
    unManageRank: null,
    city: '',
  };

  jobRules: any = [
    {
      required: true,
      message: '请输入职务',
    },
    {
      validator: this.validateContent,
      message: '职务不能为“暂无”或者“无”',
    },
  ];

  validateContent(value, callback) {
    if (value === '暂无' || value === '无') {
      return false;
    } else {
      return true;
    }
  }

  onPcitysConfirm(pcity) {
    this.form.city = pcity;
    // if (pcity[0].name != pcity[1].name) {
    //   this.form.city = pcity[0].name + pcity[1].name;
    // } else {
    //   this.form.city = pcity[0].name;
    // }
    this.showCitySelectorPicker = false;
  }
  onPcitysCancel() {
    this.showCitySelectorPicker = false;
  }

  async mounted() {
    // this.pcList = PcList;
    if (this.$route.params.userInfo) {
      this.form = JSON.parse(this.$route.params.userInfo);
      this.formDeptName = JSON.parse(this.$route.params.userInfo).deptName;
      this.getAllDepts();

      if (this.form.imageName) {
        this.getStuImg('学员头像', this.form.imageName);
      }
    } else {
      const { data } = await api.AccountApp.getUserPersonalInfo_GET();
      this.form = data;

      this.getAllDepts();
    }
  }

  manRankConfirm(val) {
    this.form.postRank = val.order;
    this.postRankValue = val.name;
    this.showManageRankPicker = false;
  }
  unManRankConfirm(val) {
    this.form.unManageRank = val.order;
    this.unManageRankValue = val.name;
    this.showUnManageRankPicker = false;
  }

  async getAllDepts() {
    const { data } = await api.AccountApp.getAllDepts_GET();
    const deptName = data.find((e: { deptId: any }) => this.form.deptId == e.deptId).deptName;
    Vue.set(this.form, 'deptName', deptName);
  }

  deptBind(depts: any) {
    depts.forEach((item: any) => {
      if (this.form.deptId == item.deptId) {
        Vue.set(this.form, 'deptName', item.deptName);
      }
    });
  }

  async onSubmit() {
    if (this.form.unManageRank == null && this.form.postRank == null) {
      Dialog.alert({
        title: '提示',
        message: '职务层次与职级至少要填写一个！',
      });
      return;
    }
    try {
      // this.feedbackShow = true;
      const { data, success, message } = await api.AccountApp.editStudentInfo_POST(this.form);

      if (success) {
        await UserModule.GetInfo();
        // this.successStatu = true;
        Toast.success('修改成功');

        if (this.$route.query.redirect) {
          this.$router.push({ path: this.$route.query.redirect as string });
        }
      } else {
        Toast.fail(`提交失败，原因:${message}`);
        // this.successStatu = false;
        // this.errorMsg = message;
      }
      SessionModule.getActiveSession.deptName = this.formDeptName;
      SessionModule.getActiveSession.name = this.form.name;
    } finally {
      this.loading = false;
      this.finished = true;
    }
    this.feedbackType = '学员信息';
  }
  //关闭提交状态对话框回调事件
  feedbaclCancle() {
    this.feedbackShow = false;
  }

  dateConfirm(val: any) {
    this.showDatePicker = false;
    this.form.birthday = datetime(val, 'YYYY-MM-DD');
  }
  dateCancel() {
    this.showDatePicker = false;
  }

  nationConfirm(val: string) {
    this.showNationPicker = false;
    this.form.nation = val;
  }
  nationCancel() {
    this.showNationPicker = false;
  }
  deptConfirm(dept: any) {
    this.showDeptPicker = false;
    this.formDeptName = dept.deptName;
    this.form.deptId = dept.deptId;
  }
  deptCancel() {
    this.showDeptPicker = false;
  }
  beforeUpload(file: any) {
    if (file.type != 'image/jpeg' && file.type != 'image/png') {
      Dialog.alert({
        message: '请上传jpg或png格式的图片',
      });
      return false;
    }
    return true;
  }
  async afterUpload(file: any) {
    let _this = this;
    _this.stuImgs = [];
    _this.previewImg = file.content;
    _this.form.imageName = _this.genGuid();
    await _this.uploadFile(file, _this.form.imageName);
  }
  async uploadFile(file: any, key: string) {
    let formData = new FormData();
    formData.append('file', file.file);
    formData.append('StringKey1', key);
    formData.append('Category', '学员头像');
    try {
      await apiAxios
        .post('/api/NewAttachment/Upload', formData, axiosOptions)
        .then(res => {})
        .catch(err => {});
    } catch (err) {
      Dialog.alert({
        message: '上传失败',
      });
    }
  }
  // 获取学员头像
  async getStuImg(keyName: string, key: string) {
    const { data } = await apiAxios.get('/api/NewAttachment/GetAttachmens', {
      params: {
        StringKey1: key,
        Category: keyName,
      },
    });
    this.stuImgs = data;
  }
  genGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      let r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}
export interface AxiosRequestConfig {
  baseURL?: string;
  headers: object;
}
const axiosOptions: AxiosRequestConfig = {
  baseURL: process.env.VUE_APP_ROOT,
  headers: {
    Authorization: `${'Bearer ' + UserModule.getToken}`,
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
};
const apiAxios = axios.create(axiosOptions);
